import React from 'react';
export const TableContext = React.createContext();
//# sourceMappingURL=TableContext.js.map